export default __webpack_public_path__ + "static/media/mysql.b0423539.svg";